
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Vileparletopunecabservice() {



    const cardData =
    {
        keyword: 'Vile Parle to Pune Cab Service ',
        heading: 'Skyline Cabs: Vile Parle to Pune Cab Service ',
        headingDescription: 'Skyline Cabs offers smooth and dependable Vile Parle to Pune Cab Service for a stress-free travel experience. Whether you are traveling for business, leisure, or visiting family, our well-maintained vehicles and professional drivers ensure a safe and comfortable journey. With prompt pickups from Vile Parle, affordable pricing, and 24/7 customer support, we make intercity travel easy and convenient. Book your Vile Parle to Pune cab with Skyline Cabs and enjoy a relaxing ride from start to finish.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Vile Parle to Pune Cab Service",
      "description": "Skyline Cabs offers comfortable and affordable cab services from Vile Parle to Pune. Choose from a variety of vehicle options like Innova Crysta, Ertiga, and sedans, ensuring a smooth and comfortable journey."
    },
    {
      "name": "Vile Parle to Pune Cab Service Contact Number",
      "description": "To book a cab from Vile Parle to Pune, contact Skyline Cabs at [Insert contact number]. Our team is ready to assist with your booking and ensure you have a hassle-free ride."
    },
    {
      "name": "Santacruz to Pimpri Chinchwad Cab Service",
      "description": "Skyline Cabs offers reliable and affordable cab services from Santacruz to Pimpri Chinchwad. With experienced drivers and comfortable vehicles, we ensure a smooth and safe journey."
    },
    {
      "name": "Santacruz to Pune Station Cab Fare",
      "description": "Get the best pricing for a taxi from Santacruz to Pune Station with Skyline Cabs. Our pricing is transparent, and we provide a variety of vehicles to suit your travel needs."
    },
    {
      "name": "Mumbai to Pune Taxi Service",
      "description": "Skyline Cabs provides excellent taxi services from Mumbai to Pune. Choose from a wide range of vehicles, including SUVs and sedans, with affordable rates and punctual service."
    },
    {
      "name": "Taxi Service in Vile Parle",
      "description": "Skyline Cabs offers dependable and affordable taxi services in Vile Parle, Mumbai. Whether you need a local ride or are heading outstation, our fleet of well-maintained vehicles is ready for you."
    },
    {
      "name": "Nehru Nagar to Pune Cab Service",
      "description": "Travel from Nehru Nagar to Pune with Skyline Cabs. Our affordable taxi service includes a range of vehicles including Innova Crysta, Ertiga, and sedans to ensure a comfortable journey."
    },
    {
      "name": "Sahara Airport to Pune Taxi Service",
      "description": "Skyline Cabs provides reliable taxi services from Sahara Airport to Pune. We offer a range of vehicles, including premium options like the Innova Crysta, for a comfortable and timely journey."
    },
    {
      "name": "Sahara Airport to Pimpri Chinchwad Taxi Service",
      "description": "Skyline Cabs offers timely and affordable taxi services from Sahara Airport to Pimpri Chinchwad. Book online or contact us for a stress-free ride."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      "description": "Skyline Cabs offers online booking for taxis from Mumbai Airport to Pune. Choose from a variety of vehicle options, including luxury cabs and affordable choices, all with transparent pricing."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs provides affordable taxi services from Mumbai to Pune with transparent fare rates. We offer various vehicle options such as Innova Crysta, Ertiga, and sedans, ensuring a comfortable ride."
    },
    {
      "name": "Mumbai to Pune Car Rental",
      "description": "Rent a car with Skyline Cabs for your journey from Mumbai to Pune. We offer a variety of vehicles, including luxury and economy options, to cater to all your travel needs."
    },
    {
      "name": "Mumbai to Pune Cab Charges",
      "description": "Skyline Cabs provides transparent and affordable cab charges for your ride from Mumbai to Pune. Our fares cover all costs, including tolls, fuel, and driver charges."
    },
    {
      "name": "Mumbai to Pune Cab Fare",
      "description": "Book your Mumbai to Pune cab with Skyline Cabs for the best fares in the market. Our pricing is competitive, with no hidden charges."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Skyline Cabs offers an easy and convenient online cab booking system for your trip from Mumbai to Pune. Select your vehicle, confirm your booking, and enjoy a hassle-free ride."
    },
    {
      "name": "Cab Service in Mumbai",
      "description": "Skyline Cabs provides reliable and affordable cab services across Mumbai. Whether you need a local ride or an outstation trip, we have a wide range of vehicles to choose from."
    },
    {
      "name": "Cab Booking Mumbai",
      "description": "Skyline Cabs offers quick and easy online booking for all types of taxis in Mumbai. Book your ride from the comfort of your home or office."
    },
    {
      "name": "Mumbai Taxi Service",
      "description": "Skyline Cabs provides professional taxi services across Mumbai, including airport transfers, local travel, and outstation journeys. Our fleet includes everything from economy sedans to premium SUVs."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs offers the cheapest cab services in Mumbai without compromising on quality. Our transparent pricing ensures that there are no hidden charges, and you can enjoy affordable rides."
    },
    {
      "name": "Cab Service in Vile Parle",
      "description": "Skyline Cabs offers the best cab service in Vile Parle. Whether you need a local ride, airport transfer, or outstation trip, we ensure timely service at affordable prices."
    },
    {
      "name": "Cab Service in Vile Parle",
      "description": "Skyline Cabs provides excellent cab services in Vile Parle for both local and outstation trips. Book your ride with us for a comfortable and affordable journey."
    },
    {
      "name": "Best Cab in Vile Parle",
      "description": "Skyline Cabs offers the best cab service in Vile Parle, Mumbai. Choose from a variety of vehicles, including sedans, SUVs, and premium options, to enjoy a safe and comfortable ride."
    }
  ],
  "tableData": [
    ["Vile Parle to Pune Cab Service", "Vile Parle to Pune Cab Service Contact Number"],
    ["Santacruz to Pimpri Chinchwad Cab Service", "Santacruz to Pune Station Cab Fare"],
    ["Mumbai to Pune Taxi Service", "Taxi Service in Vile Parle"],
    ["Nehru Nagar to Pune Cab Service", "Sahara Airport to Pune Taxi Service"],
    ["Sahara Airport to Pimpri Chinchwad Taxi Service", "Mumbai Airport to Pune Taxi Online Booking"],
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
    ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Fare"],
    ["Mumbai to Pune Cab Booking", "Cab Service in Mumbai"],
    ["Cab Booking Mumbai", "Mumbai Taxi Service"],
    ["Cheapest Cab Service in Mumbai", "Cab Service in Vile Parle"],
    ["Cab Service in Vile Parle", "Best Cab in Vile Parle"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Vile Parle to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable and timely cab services from Vile Parle to Pune. Whether you are heading for business or leisure, our professional service guarantees that you’ll reach your destination comfortably and on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet includes a range of vehicles to suit your needs, from comfortable sedans to spacious SUVs and luxury cars. All of our vehicles are air-conditioned, well-maintained, and equipped with ample legroom, ensuring a smooth and enjoyable journey from Vile Parle to Pune."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Skyline Cabs’ drivers are professional, experienced, and well-versed in the best routes from Vile Parle to Pune. They prioritize your safety, comfort, and punctuality, ensuring a hassle-free and enjoyable ride every time."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "With Skyline Cabs, you always know the fare upfront, with no hidden charges. Our transparent pricing structure ensures you get the best value for your ride, with affordable rates for the high-quality service we provide."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel",
        "WhyChoosedescription": "Skyline Cabs operates round-the-clock, giving you the flexibility to book a cab for your Vile Parle to Pune trip at any time of the day or night. Whether it’s an early morning departure or a late-night return, we’ve got you covered."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your Vile Parle to Pune cab is quick and easy with Skyline Cabs. Use our website or mobile app to book your ride in just a few clicks, with instant booking confirmation and the ability to track your driver in real-time."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles for Every Journey",
        "WhyChoosedescription": "Your safety and hygiene are our priority. All of our vehicles are regularly cleaned and sanitized after each ride, and our drivers follow strict safety protocols to ensure a clean and secure environment for your Vile Parle to Pune trip."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "We understand that each traveler has unique needs. Whether you’re traveling solo, with family, or in a group, Skyline Cabs offers a variety of vehicle options to ensure you have the right space and comfort for your journey from Vile Parle to Pune."
    }
]


























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Vile Parle to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Vile Parle to Pune is quick and easy. You can either book through our website, mobile app, or call our customer service team for assistance. Simply enter your pickup and drop-off locations, select your preferred vehicle, and confirm your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Vile Parle to Pune trip?',
            answer:
                'We offer a variety of vehicles to suit your needs, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose the vehicle based on the number of passengers and your comfort preferences.',
        },
        {
            id: 3,
            question: 'What is the estimated travel time from Vile Parle to Pune?',
            answer:
                'The travel time from Vile Parle to Pune typically ranges between 3.5 to 5 hours, depending on the traffic conditions. Our professional drivers take the most efficient routes to ensure a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Vile Parle to Pune cab fixed?',
            answer:
                'Yes, the fare for your journey is fixed and includes all charges such as tolls, taxes, and driver fees. You’ll be provided with a clear breakdown of the fare before confirming your booking, ensuring complete transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Vile Parle to Pune?',
            answer:
                'Yes, you can easily book a round-trip service. Provide your return trip details when you make your booking, and we’ll ensure a comfortable return journey as well.',
        },
        {
            id: 6,
            question: 'Is there a customer support team available for assistance?',
            answer:
                'Yes, our customer support team is available 24/7 to assist with bookings, cancellations, or any queries related to your Vile Parle to Pune cab service.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Vile Parle to Pune well-maintained?',
            answer:
                'Absolutely! All our vehicles are regularly maintained, clean, and equipped with essential amenities for a comfortable and safe journey. We ensure our vehicles are in top condition for every trip.',
        },
        {
            id: 8,
            question: 'Can I make an online payment for my Vile Parle to Pune cab?',
            answer:
                'Yes, you can make secure online payments via credit/debit cards, UPI, or net banking. We also accept cash payments if that is more convenient for you.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs suitable for corporate travel from Vile Parle to Pune?',
            answer:
                'Yes, we offer customized corporate travel services for business trips. Whether you need a cab for meetings or group travel, we can tailor our services to meet your corporate needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Vile Parle to Pune journey?',
            answer:
                'Skyline Cabs offers reliable, safe, and comfortable transportation with professional drivers and well-maintained vehicles. We prioritize customer satisfaction, timely services, and transparent pricing to ensure a stress-free journey from Vile Parle to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Kapoor",
            rating: 5,
            review: "I frequently travel from Vile Parle to Pune for business, and Skyline Cabs has always been my preferred choice. The drivers are professional, and the cars are always clean and comfortable. I trust them for a hassle-free journey every time."
        },
        {
            name: "Miss. Rhea Sharma",
            rating: 4,
            review: "I booked a cab for a weekend trip to Pune from Vile Parle. The entire experience was smooth—the booking process was simple, and the driver was very polite and punctual. I’ll definitely be using Skyline Cabs for my future trips."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vile Parle to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/vile-parle-to-pune-cab.jpg",
  "description": "Book Vile Parle to Pune cabs with Skyline Cabs for a hassle-free and budget-friendly ride. Choose from AC sedans or SUVs with verified drivers, available 24/7 for one-way and round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7294"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/vile-parle-to-pune-cabs"
  }
};



      
     

    return (
        <div>
<Helmet>
  <title>Vile Parle to Pune Cabs | 24x7 AC Taxi Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Vile Parle to Pune cabs with Skyline Cabs for a hassle-free and budget-friendly ride. Choose from AC sedans or SUVs with verified drivers, available 24/7 for one-way and round-trip journeys." 
  />
  <meta 
    name="keywords" 
    content="Vile Parle to Pune Cabs, Cab from Vile Parle to Pune, One-Way Taxi Vile Parle to Pune, Round Trip Cab Vile Parle to Pune, AC Cab Vile Parle to Pune, SUV Taxi Vile Parle to Pune, Affordable Taxi Vile Parle to Pune, 24/7 Cab Booking Vile Parle to Pune, Online Cab Vile Parle to Pune, Skyline Cabs Vile Parle to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vileparletopunecabservice;